// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import { local } from 'wix-storage';
import { changeUserDetails } from 'backend/auth';
import { changeImage } from 'backend/auth';
import moment from 'moment';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(function () {
    console.log('user ', JSON.parse(local.getItem('user')));
    let user = JSON.parse(local.getItem('user'));
    let name = user.Name + ' ' + user.Last;
    let email = user.Email;
    let phone = user.Phone;
    let city = user.City;

    if (Number(user.Level) === 2) {
        $w('#lawyerTitle').expand();
        $w('#lawyerInfo').expand();
        if (user.LawyerInfo !== '') {
            $w('#lawyerInfo').value = user.LawyerInfo;
        }
    }

    $w('#name').text = name;
    $w('#email').text = email;
    $w('#phone').text = phone;
    $w('#city').text = city;
    console.log(user.ID);

    let avatar = 'http://pravo.deystvie.org/avatars/default.jpg';

    if (Number(user.PicChanged) === 1) {
        avatar = 'https://pravo.deystvie.org/avatars/avatar\-' + user.ID + '.png?now=' + moment(new Date()).format("DD-MM-YYYY-mm-ss");
    }

    console.log(avatar);
    $w('#imageToReplace').src = avatar;
    $w('#imageToReplace').expand();

});

export function changePhoneBtn_click(event) {
    if ($w("#newPhone").collapsed) {
        $w("#newPhone").expand();
        $w('#phone').collapse();
    } else {
        $w("#newPhone").collapse();
        $w('#phone').expand();
    }
}

export function changeCityBtn_click(event) {
    if ($w("#newCity").collapsed) {
        $w("#newCity").expand();
        $w('#city').collapse();
    } else {
        $w("#newCity").collapse();
        $w('#city').expand();
    }
}

export function changePassBtn_click(event) {
    if ($w("#currentPass").collapsed) {
        $w("#currentPass").expand();
        $w("#newPass").expand();
        $w("#reNewPass").expand();
    } else {
        $w("#currentPass").collapse();
        $w("#newPass").collapse();
        $w("#reNewPass").collapse();
    }
}

export function saveBtn_click(event) {
    let newPhone = $w('#newPhone').value === '' ? false : $w('#newPhone').value;
    let newCity = $w('#newCity').value === '' ? false : $w('#newCity').value;
    let currentPassword = $w('#currentPass').value === '' ? false : $w('#currentPass').value;
    let newPassword = $w('#newPass').value === '' ? false : $w('#newPass').value;
    let reNewPassword = $w('#reNewPass').value === '' ? false : $w('#reNewPass').value;
    let lawyerInfo = $w('#lawyerInfo').value === '' ? false : $w('#lawyerInfo').value;
    let image = false;

    if (!$w('#success').collapsed) {
        $w('#success').collapse();
    }

    if (!$w('#error').collapsed) {
        $w('#error').collapse();
    }

    if (local.getItem('imageUrl')) {
        image = local.getItem('imageUrl');
    }

    if (newPassword && currentPassword && reNewPassword) {
        if (reNewPassword !== newPassword) {
            currentPassword = false;
            newPassword = false;
            reNewPassword = false;
            $w('#currentPass').value = '';
            $w('#newPass').value = '';
            $w('#reNewPass').value = '';
            $w('#error').text = 'Паролите не съвпадат!';
            $w('#error').expand();
        } else if (newPassword.length < 6) {
            currentPassword = false;
            newPassword = false;
            reNewPassword = false;
            $w('#currentPass').value = '';
            $w('#newPass').value = '';
            $w('#reNewPass').value = '';
            $w('#error').text = 'Паролата трябва да е поне 6 символа!';
            $w('#error').expand();
        }
    }

    let userID = JSON.parse(local.getItem('user')).ID;

    $w('#saveBtn').collapse();
    $w('#loading').expand();

    changeUserDetails(userID, newPhone, newCity, newPassword, currentPassword, image, lawyerInfo).then(response => {
        if (response.error) {
            console.log('errror res: ', response);
            throw new Error(response.error.message);
        }

        console.log(response.ID);
        console.log('res', response);

        if (Number(response.PicChanged) === 1) {
            let avatar = 'https://pravo.deystvie.org/avatars/avatar\-' + response.ID + '.png?now=' + moment(new Date()).format("DD-MM-YYYY-mm-ss");
            $w('#imageToReplace').src = avatar;
        }

        // let avatar = 'https://pravo.deystvie.org/avatars/avatar\-' + response.ID + '.png';

        $w('#phone').text = response.Phone;

        if (!($w('#newPhone').collapsed)) {
            $w('#newPhone').collapse();
            $w('#phone').expand();
        }

        $w('#city').text = response.City;

        if (!($w('#newCity').collapsed)) {
            $w('#newCity').collapse();
            $w('#city').expand();
        }

        if (!($w('#currentPass').collapsed)) {
            $w('#currentPass').collapse();
        }

        if (!($w('#newPass').collapsed)) {
            $w('#newPass').collapse();
        }

        if (!($w('#reNewPass').collapsed)) {
            $w('#reNewPass').collapse();
        }
        if (local.getItem('imageUrl')) {
            local.removeItem('imageUrl');
        }
        local.setItem('user', JSON.stringify(response));
        if (newPhone || newCity || currentPassword || newPassword || reNewPassword || lawyerInfo || image) {
            $w('#success').text = 'Успешно направихте промените си.'
            $w('#success').expand();

            $w('#newPhone').value = '';
            $w('#newCity').value = '';
            $w('#currentPass').value = '';
            $w('#newPass').value = '';
            $w('#reNewPass').value = '';

            if (!lawyerInfo) {
                $w('#lawyerInfo').value = '';
            }

            $w('#newPhone').resetValidityIndication();
            $w('#newCity').resetValidityIndication();
            $w('#currentPass').resetValidityIndication();
            $w('#newPass').resetValidityIndication();
            $w('#reNewPass').resetValidityIndication();
            $w('#lawyerInfo').resetValidityIndication();

            image = false;
            newPhone = false;
            newCity = false;
            currentPassword = false;
            newPassword = false;
            reNewPassword = false;
            lawyerInfo = false;

        }
        $w('#loading').collapse();
        $w('#saveBtn').expand();

        // wixLocation.to(wixLocation.url);
    }).catch(error => {
        if (error.message === 'INVALID_PASSWORD') {
            $w('#currentPass').value = '';
            $w('#newPass').value = '';
            $w('#reNewPass').value = '';
            $w('#error').text = 'Грешна парола!';
            $w('#error').expand();
        }
        $w('#loading').collapse();
        $w('#saveBtn').expand();
        if (!$w('#success').collapsed) {
            $w('#success').collapse();
        }
        console.log(error);
    });
}

export function uploadBtn_change(event) {
    if ($w("#uploadBtn").value.length > 0) { // user chose a file
        let fileName = $w("#uploadBtn").value[0].name;
        console.log("Uploading " + fileName);
        if (fileName.endsWith('.png') || fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.PNG') || fileName.endsWith('.JPG') || fileName.endsWith('.JPEG')) {
            $w('#saveBtn').collapse();
            $w('#loading').expand();
            $w("#uploadBtn").startUpload()
                .then((uploadedFile) => {
                    console.log(uploadedFile.mediaId);
                    let imageUrl = 'https://static.wixstatic.com/media/' + uploadedFile.mediaId;
                    local.setItem('imageUrl', imageUrl);
                    $w('#loading').collapse();
                    $w('#saveBtn').expand();
                }).catch((uploadError) => {
                    console.log("File upload error: " + uploadError.errorCode);
                    console.log(uploadError.errorDescription);
                    $w('#loading').collapse();
                    $w('#saveBtn').expand();
                });
        } else {
            $w('#error').text = 'Файлът трябва да е от тип .png или .jpg';
            $w('#error').expand();
        }
    } else { // user clicked button but didn't chose a file
        console.log("Please choose a file to upload.");
    }
}

export function closeBtn_click(event) {
    wixWindow.lightbox.close();
}